export const marketKeyName = [
  ['OddValue1', 'OddValue2', 'OddValue3'],
  ['OddValueFirstScore_1', 'OddValueFirstScore_None', 'OddValueFirstScore_2'],
  ['RestThreeWay1', 'RestThreeWayX', 'RestThreeWay2'],
  ['Total1OverOddValue', 'Total1UnderOddValue', 'Total2OverOddValue', 'Total2UnderOddValue', 'Total3OverOddValue', 'Total3UnderOddValue'],
  ['OddValueFirstHalf_1', 'OddValueFirstHalf_X', 'OddValueFirstHalf_2', 'OddValueTennisFirstSet1', 'OddValueTennisFirstSet2', 'Total3UnderOddValue'],
  ['OddValueFirstHalfNG_1', 'OddValueFirstHalfNG_X', 'OddValueFirstHalfNG_2'],
  ['OddValueFirstHalfRS_1', 'OddValueFirstHalfRS_X', 'OddValueFirstHalfRS_2'],
  ['HalfTotal1OverOddValue', 'HalfTotal1UnderOddValue', 'HalfTotal2OverOddValue', 'HalfTotal2UnderOddValue', 'HalfTotal3OverOddValue', 'HalfTotal3UnderOddValue'],
  ['OddValueFirstScore_1', 'OddValueFirstScore_None', 'OddValueFirstScore_2'],
  ['OddValueRestThreeWay1', 'OddValueRestThreeWayX', 'OddValueRestThreeWay2'],
  ['OddValueTotal1Over', 'OddValueTotal1Under', 'OddValueTotal2Over', 'OddValueTotal2Under', 'OddValueTotal3Over', 'OddValueTotal3Under'],
  ['OddValueFirstHalf_1', 'OddValueFirstHalf_X', 'OddValueFirstHalf_2', 'OddValueTennisFirstSet1', 'OddValueTennisFirstSet2'],
  ['OddValueFirstHalfNG_1', 'OddValueFirstHalfNG_X', 'OddValueFirstHalfNG_2'],
  ['OddValueFirstHalfRS_1', 'OddValueFirstHalfRS_X', 'OddValueFirstHalfRS_2'],
  ['OddValueHalfTotal1Over', 'OddValueHalfTotal1Under', 'OddValueHalfTotal2Over', 'OddValueHalfTotal2Under', 'OddValueHalfTotal3Over', 'OddValueHalfTotal3Under'],
];

export const oddLiveMarketingBasketball = [0, 10, 16, 17]; // Basketball
export const oddLiveMarketingTennis = [0, 10, 18, 20]; // Tennis
export const oddLiveMarketingIceHockey = [0, 9, 10, 19]; // IceHockey
export const oddLiveMarketingVolleyball = [0, 10, 18, 21]; // Volleyball
export const oddLiveMarketingBaseball = [0, 10, 16, 17]; // Baseball
export const oddLiveMarketingHandball = [0, 9, 10, 11]; // Handball
export const oddLiveMarketingTableTennis = [0, 9, 10, 18]; // TableTennis
export const oddLiveMarketingTableSoccer = [0, 9, 8, 24]; // TableTennis
export const oddLiveMarketingAmericanFootball = [0, 10, 18, 20]; // American Football

export const soccerOddComboList: oddComboListType[] = [
  { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', 'X', '2'] },
  { OddId: 9, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: ['1', 'X', '2'] },
  { OddId: 8, OddNameLong: 'NextGoal', OddNameLong2: '', OddName: 'NT', OddTitles: ['1', 'X', '2'] },
  { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
  { OddId: 22, OddNameLong: 'handicap', OddNameLong2: '', OddName: 'hc', OddTitles: ['', '1', 'X', '2'] },
  { OddId: 23, OddNameLong: 'DoppelteChance', OddNameLong2: '', OddName: 'DC', OddTitles: ['1X', '12', 'X2'] },
  { OddId: 24, OddNameLong: 'Treffenbeide?', OddNameLong2: '', OddName: 'TF?', OddTitles: ['Y', 'N'] },
  { OddId: 11, OddNameLong: 'HTFirstHalf', OddNameLong2: '', OddName: '1x2 HT', OddTitles: ['1', 'X', '2'] },
  { OddId: 12, OddNameLong: 'NT_HZ_long', OddNameLong2: '', OddName: 'NT_HZ', OddTitles: ['1', 'X', '2'] },
  { OddId: 13, OddNameLong: 'RoM HT', OddNameLong2: '', OddName: 'RoM HT', OddTitles: ['1', 'X', '2'] },
  { OddId: 14, OddNameLong: 'Ü/U 1.HZ_long', OddNameLong2: '', OddName: 'Ü/U 1.HZ', OddTitles: ['', '+', '-'] },
];

export const basketballOddComboList = [
  { OddId: 0, OddNameLong: '2way_long', OddNameLong2: '', OddName: '2way_short', OddTitles: ['1', '2'] },
  { OddId: 10, OddNameLong: 'O/U_basketball_long', OddNameLong2: '', OddName: 'O/U_basketball_short', OddTitles: ['', '+', '-'] },
  { OddId: 16, OddNameLong: 'HomeTotal_Long', OddNameLong2: '', OddName: 'HomeTotal_Short', OddTitles: ['', '+', '-'] },
  { OddId: 17, OddNameLong: 'AwayTotal_Long', OddNameLong2: '', OddName: 'AwayTotal_Short', OddTitles: ['', '+', '-'] },
  { OddId: 14, OddNameLong: 'Ü/U 1.HZ_long', OddNameLong2: '', OddName: 'Ü/U 1.HZ', OddTitles: ['', '+', '-'] },
  { OddId: 26, OddNameLong: 'handicap', OddNameLong2: '', OddName: 'hc', OddTitles: ['1', '2'] },
];

export const tennisOddComboList = [
  { OddId: 0, OddNameLong: '2way_long', OddNameLong2: '', OddName: '2way_short', OddTitles: ['1', '2'] },
  { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
  { OddId: 18, OddNameLong: 'TennisSet_Long', OddNameLong2: '', OddName: 'TennisSet_Short', OddTitles: ['1', '2'] },
  { OddId: 20, OddNameLong: 'TennisTotalSet_Long', OddNameLong2: '', OddName: 'TennisTotalSet_Short', OddTitles: ['1', '2'] },
];

export const americanFootballOddComboList = [
  { OddId: 0, OddNameLong: '2way_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', '2'] },
  { OddId: 0, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: ['1', '2'] },
  { OddId: 8, OddNameLong: 'NextGoal', OddNameLong2: '', OddName: 'NT', OddTitles: ['1', 'X', '2'] },
  { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
  { OddId: 22, OddNameLong: 'handicap', OddNameLong2: '', OddName: 'hc', OddTitles: ['', '1', 'X', '2'] },
  { OddId: 23, OddNameLong: 'DoppelteChance', OddNameLong2: '', OddName: 'DC', OddTitles: ['1X', '12', 'X2'] },
  { OddId: 24, OddNameLong: 'Treffenbeide?', OddNameLong2: '', OddName: 'TF?', OddTitles: ['Y', 'N'] },
  { OddId: 11, OddNameLong: 'HTFirstHalf', OddNameLong2: '', OddName: '1x2 HT', OddTitles: ['1', '2'] },
  { OddId: 12, OddNameLong: 'NT_HZ_long', OddNameLong2: '', OddName: 'NT_HZ', OddTitles: ['1', '2'] },
  { OddId: 13, OddNameLong: 'RoM HT', OddNameLong2: '', OddName: 'RoM HT', OddTitles: ['1', '2'] },
  { OddId: 14, OddNameLong: 'Ü/U 1.HZ_long', OddNameLong2: '', OddName: 'Ü/U 1.HZ', OddTitles: ['', '+', '-'] },
];

export const iceHockeyFootballOddComboList = [
  { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', '2'] },
  { OddId: 9, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: ['1', 'X', '2'] },
  { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
  { OddId: 19, OddNameLong: 'IceHockeyPeriod_Long', OddNameLong2: '', OddName: 'IceHockeyPeriod_Short', OddTitles: ['', '+', '-'] },
];

export const volleyballFootballOddComboList = [
  { OddId: 0, OddNameLong: '2way_long', OddNameLong2: '', OddName: '2way_short', OddTitles: ['1', '2'] },
  { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
  { OddId: 18, OddNameLong: 'TennisSet_Long', OddNameLong2: '', OddName: 'TennisSet_Short', OddTitles: ['1', '2'] },
  { OddId: 21, OddNameLong: 'TennisTotalSet_Long', OddNameLong2: '', OddName: 'TennisTotalSet_Short', OddTitles: ['1', 'X', '2'] },
];

export const handballFootballOddComboList = [
  { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', 'X', '2'] },
  { OddId: 9, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: ['1', 'X', '2'] },
  { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
  { OddId: 11, OddNameLong: 'HTFirstHalf', OddNameLong2: '', OddName: '1x2 HT', OddTitles: ['1', 'X', '2'] },
];

export const tableTennisFootballOddComboList = [
  { OddId: 0, OddNameLong: '2way_long', OddNameLong2: '', OddName: '2way_short', OddTitles: ['1', '2'] },
  { OddId: 9, OddNameLong: 'RestofMatch', OddNameLong2: '', OddName: 'RoM', OddTitles: ['1', 'X', '2'] },
  { OddId: 10, OddNameLong: 'O/U_long', OddNameLong2: '', OddName: 'O/U', OddTitles: ['', '+', '-'] },
  { OddId: 18, OddNameLong: 'TennisSet_Long', OddNameLong2: '', OddName: 'TennisSet_Short', OddTitles: ['1', '2'] },
];

export const baseballFootballOddComboList = [
  { OddId: 0, OddNameLong: 'tipp_long', OddNameLong2: '', OddName: 'tipp', OddTitles: ['1', '2'] },
  { OddId: 10, OddNameLong: 'O/U_basketball_long', OddNameLong2: '', OddName: 'O/U_basketball_short', OddTitles: ['', '+', '-'] },
  { OddId: 16, OddNameLong: 'HomeTotal_Long', OddNameLong2: '', OddName: 'HomeTotal_Short', OddTitles: ['', '+', '-'] },
  { OddId: 17, OddNameLong: 'AwayTotal_Long', OddNameLong2: '', OddName: 'AwayTotal_Short', OddTitles: ['', '+', '-'] },
];

export interface oddComboListType {
  OddId: number;
  OddName: string;
  OddTitles: string[];
  OddNameLong: string;
  OddNameLong2: string;
}

type sportOddModelPropsType = {
  sportId?: number;
  rowCount?: number;
};

export class SportOddModel {
  oddComboList: oddComboListType[] | [] = [];
  oddLiveMarketing: number[] | [] = [];
  rowCount = 1;
  oddComboSelected: oddComboListType[] | [] = [];
  constructor({ sportId, rowCount = 1 }: sportOddModelPropsType) {
    this.rowCount = rowCount;
    if (sportId) {
      switch (sportId) {
        case 1:
          this.oddComboList = soccerOddComboList;
          this.oddLiveMarketing = oddLiveMarketingTableSoccer.slice(0, rowCount);
          break;
        case 2:
          this.oddComboList = basketballOddComboList;
          this.oddLiveMarketing = oddLiveMarketingBasketball.slice(0, rowCount);
          break;
        case 3:
          this.oddComboList = baseballFootballOddComboList;
          this.oddLiveMarketing = oddLiveMarketingBaseball.slice(0, rowCount);
          break;
        case 4:
          this.oddComboList = iceHockeyFootballOddComboList;
          this.oddLiveMarketing = oddLiveMarketingIceHockey.slice(0, rowCount);
          break;
        case 5:
          this.oddComboList = tennisOddComboList;
          this.oddLiveMarketing = oddLiveMarketingTennis.slice(0, rowCount);
          break;
        case 6:
          this.oddComboList = handballFootballOddComboList;
          this.oddLiveMarketing = oddLiveMarketingHandball.slice(0, rowCount);
          break;
        case 17:
          this.oddComboList = tableTennisFootballOddComboList;
          this.oddLiveMarketing = oddLiveMarketingTableTennis.slice(0, rowCount);
          break;
        case 20:
          this.oddComboList = volleyballFootballOddComboList;
          this.oddLiveMarketing = oddLiveMarketingVolleyball.slice(0, rowCount);
          break;
        case 14:
          this.oddComboList = americanFootballOddComboList;
          this.oddLiveMarketing = oddLiveMarketingAmericanFootball.slice(0, rowCount);
          break;
        default:
          this.oddComboList = soccerOddComboList;
          this.oddLiveMarketing = oddLiveMarketingTableSoccer.slice(0, rowCount);
      }
    } else {
      this.oddComboList = [];
      this.oddLiveMarketing = [];
    }
  }

  public defaultSelectionOdd() {
    return this.oddLiveMarketing.slice(0, this.rowCount).map((oddMarket: number) => this.oddComboList.find((comboItem: oddComboListType) => comboItem.OddId === oddMarket));
  }
}
